class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.pointerInside = false;

    // Limit hover behavior to the existing desktop dropdown menu.
    if (!this.mainDetailsToggle.id.startsWith('Details-HeaderMenu-')) return;

    this.mainDetailsToggle.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !this.hoverQuery.matches) return;
      this.pointerInside = true;
      window.clearTimeout(this.hoverCloseTimer);
      this.mainDetailsToggle.open = true;
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    });

    this.mainDetailsToggle.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      this.pointerInside = false;
      window.clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = window.setTimeout(() => {
        if (!this.pointerInside && !this.contains(document.activeElement)) this.close();
      }, 250);
    });
  }

  onFocusOut() {
    window.setTimeout(() => {
      if (this.hoverQuery.matches && this.pointerInside) return;
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  disconnectedCallback() {
    window.clearTimeout(this.hoverCloseTimer);
    this.pointerInside = false;
  }

  onToggle() {
    this.mainDetailsToggle.querySelector('summary').setAttribute(
      'aria-expanded',
      String(this.mainDetailsToggle.open)
    );
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);